module.exports = __webpack_public_path__ + "img/pro-p-slider21.84521821.jpg";